import { gql } from '../../../apollo/__generated__';

export const MY_UNTARGETED_USERS = gql(`
  query MyUntargetedUsers($eventId: ID!) {
    myUntargetedUsers(eventId: $eventId) {
      id
      firstname
      nickname
      studies
      studyTown
      images {
        id
        url
      }
    }
  }
`);
